import { componentAt, components as components_ } from "./game";
let components = [];
components_.subscribe(v => components = v);
export function updateComponents(components) {
    // reset
    for (let component of components) {
        component.powered = false;
        component.beforeTick(componentAt);
    }
    function run() {
        let stack = [...components];
        let popped = [];
        let iterations = 0;
        while (stack.length > 0) {
            iterations++;
            if (iterations > 1000)
                break;
            if (stack[0].tick(componentAt)) {
                stack.push(...popped);
            }
            popped.push(stack.shift());
        }
        for (let component of components) {
            if (component.afterTick(componentAt)) {
                run();
            }
        }
    }
    run();
}
function loop() {
    updateComponents(components);
    requestAnimationFrame(loop);
}
requestAnimationFrame(loop);
